import { render, staticRenderFns } from "./SingleCardPurchaseOptions.vue?vue&type=template&id=27875da5&scoped=true"
import script from "./SingleCardPurchaseOptions.vue?vue&type=script&lang=ts"
export * from "./SingleCardPurchaseOptions.vue?vue&type=script&lang=ts"
import style0 from "./SingleCardPurchaseOptions.vue?vue&type=style&index=0&id=27875da5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27875da5",
  null
  
)

export default component.exports